/**
 * If type union does not contain null, it marks it as NonNullable.
 */
type RemoveUndefinedIfNullProperty<T> = null extends T ? T : NonNullable<T>

/**
 * Extracts the array elements to pass to RecursiveRemoveUndefined.
 */
type RemoveUndefinedIfNullArray<A> = A extends readonly (infer I)[] ? RecursiveRemoveUndefined<I> : never

// TODO: It's going down two levels, not going further recursivly.
/**
 * Iterates through props of T.
 * If prop type union contains null, leaves it as is.
 * If prop type union does not contain null, marks it as NonNullable.
 * Motivation: mst-gql adds types.undefined to every prop in a model. This causes types derivated from that model to wrongly contain props that are marked as possibly undefined.
 */
export type RecursiveRemoveUndefined<T> = {
  [K in keyof T]: unknown[] extends T[K]
    ? RemoveUndefinedIfNullArray<T[K]>
    : T[K] extends Record<string, unknown>
      ? RecursiveRemoveUndefined<T[K]>
      : RemoveUndefinedIfNullProperty<T[K]>
}
